import { createSlice } from '@reduxjs/toolkit';
import initialState from './employeeDocumentsFilterInitialState';
import {
  _setCompany,
  _setDocumentType,
  _setIncludeExpired,
  _setIsActiveCompanyAssociation,
} from './employeeDocumentsFilterAction';

export const employeeDocumentsFilterSlice = createSlice({
  name: 'delta/employeeDocumentsFilter',
  initialState,
  reducers: {
    setCompany: _setCompany,
    setDocumentType: _setDocumentType,
    setIncludeExpired: _setIncludeExpired,
    setIsActiveCompanyAssociation: _setIsActiveCompanyAssociation,
    resetEmployeeDocumentsFilter: () => initialState,
  },
});

export const {
  setCompany,
  setDocumentType,
  setIncludeExpired,
  setIsActiveCompanyAssociation,
  resetEmployeeDocumentsFilter,
} = employeeDocumentsFilterSlice.actions;

export default employeeDocumentsFilterSlice.reducer;
